import type { KeyboardEvent, MouseEvent } from 'react';

export type EventoDeAtivacao = MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>;

/** Props que tornam um contêiner clicável de fato acionável. */
export interface PropsDeAtivacao {
    role: 'button';
    tabIndex: 0;
    'aria-label'?: string;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => void;
}

/**
 * Converte um `onClick` num conjunto acionável por teclado.
 *
 * Um `<article>` ou `<section>` com apenas `onClick` é invisível para quem
 * navega por Tab: não recebe foco, não é anunciado como ação e não responde a
 * Enter nem Espaço. Devolve `undefined` quando não há `onClick`, para que o
 * elemento continue sendo o contêiner semântico que era — anexar `role="button"`
 * a um card não clicável seria mentir sobre ele.
 *
 * Não use em `<tr>`: `role` numa linha a remove da árvore da tabela, e o leitor
 * de tela perde linha e coluna. Ver `DataTable`.
 */
export function propsDeAtivacao(
    onClick: ((e: EventoDeAtivacao) => void) | undefined,
    ariaLabel?: string
): PropsDeAtivacao | undefined {
    if (!onClick) return undefined;
    return {
        role: 'button',
        tabIndex: 0,
        'aria-label': ariaLabel,
        onClick: (e) => onClick(e),
        onKeyDown: (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            onClick(e);
        },
    };
}
